<!--begin::Partners List-->
<div *ngIf="partners && partners.length" class="row" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
  <div class="col-md-4 item-wrapper" *ngFor="let partner of (partners)">
    <sng-partner-card [partner]="partner" (mousedown)="mousedown()" (mousemove)="mousemove()" (mouseup)="mouseup(partner)">
    </sng-partner-card>
  </div>
</div>
<!--end::Partners List-->

<!--begin::Partner Modal-->
<ng-template #partnerModal let-c="close" let-d="dismiss">
  <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <sng-partner-single [partner]="partner">
  </sng-partner-single>
</ng-template>
<!--end::Partner Modal-->